<SettingsLayout page='settings/general' label="{"General"}">
  <h1>{"General settings"}</h1>

  <h2 id="section-media">{"Media"}</h2>
  <form class="ui-settings">
    <label class="setting-group">
      <input type="checkbox" id="choice-never-mark-media-sensitive"
             bind:checked="$neverMarkMediaAsSensitive" on:change="onChange(event)">
      {"Show sensitive media by default"}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-show-all-spoilers"
             bind:checked="$showAllSpoilers" on:change="onChange(event)">
      {"Expand content warnings by default"}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-use-blurhash"
              bind:checked="$ignoreBlurhash" on:change="onChange(event)">
      {"Show a plain gray color for sensitive media"}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-mark-media-sensitive"
             bind:checked="$markMediaAsSensitive" on:change="onChange(event)">
      {"Treat all media as sensitive"}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-autoplay-gif"
             bind:checked="$autoplayGifs" on:change="onChange(event)">
      {"Autoplay animated GIFs"}
    </label>
  </form>

  <h2 id="section-ui">{"UI"}</h2>
  <form class="ui-settings">
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-custom-scrollbars"
             bind:checked="$disableCustomScrollbars" on:change="onChange(event)">
      {"Disable custom scrollbars"}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-infinite-scroll"
             bind:checked="$disableInfiniteScroll" on:change="onChange(event)">
      {"Disable"}
        <Tooltip
          text="{"infinite scroll"}"
          tooltipText="{"When infinite scroll is disabled, new posts will not automatically appear at the bottom or top of the timeline. Instead, buttons will allow you to load more content on demand."}"
        />
      {[]}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-hide-cards"
             bind:checked="$hideCards" on:change="onChange(event)">
      {"Hide link preview cards"}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-underline-links"
             bind:checked="$underlineLinks" on:change="onChange(event)">
      {"Underline links in posts and profiles"}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-center-nav"
             bind:checked="$centerNav" on:change="onChange(event)">
      {"Center the navigation bar"}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-bottom-nav"
             bind:checked="$bottomNav" on:change="onChange(event)">
      {"Place the navigation bar at the bottom of the screen"}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-hide-long-posts"
             bind:checked="$hideLongPosts" on:change="onChange(event)">
      {"Collapse long posts without content warnings"}
    </label>
  </form>

  <h2 id="section-accessibility">{"Accessibility"}</h2>
  <form class="ui-settings">
    <label class="setting-group">
      <input type="checkbox" id="choice-reduce-motion"
             bind:checked="$reduceMotion" on:change="onChange(event)">
      {"Reduce motion in UI animations"}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-always-show-focus-ring"
             bind:checked="$alwaysShowFocusRing" on:change="onChange(event)">
      {"Always show"}
      <Tooltip
        text="{"focus ring"}"
        tooltipText="{"The focus ring is the outline showing the currently focused element. By default, it's only shown when using the keyboard (not mouse or touch), but you may choose to always show it."}"
      />
      {[]}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-tap-on-status"
             bind:checked="$disableTapOnStatus" on:change="onChange(event)">
      {"Disable tappable area on entire post"}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-omit-emoji-in-display-names"
             bind:checked="$omitEmojiInDisplayNames" on:change="onChange(event)">
      {"Remove emoji from user display names"}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-long-aria-labels"
             bind:checked="$disableLongAriaLabels" on:change="onChange(event)">
      {"Use short article ARIA labels"}
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-grayscale"
             bind:checked="$enableGrayscale" on:change="onChange(event)">
      {"Show emojis, images, and videos in grayscale"}
    </label>
  </form>

  <h2 id="section-wellness">{"Wellness"}</h2>

  <form class="ui-settings">
    <p>
      {"Wellness settings are designed to reduce the addictive or anxiety-inducing aspects of social media. Choose any options that work well for you."}
    </p>

    <label class="setting-group">
      <input type="checkbox" id="choice-check-all"
             on:change="onCheckAllChange(event)">
      {"Enable all"}
    </label>
    <h3>{"Metrics"}</h3>
      <label class="setting-group">
        <input type="checkbox" id="choice-disable-follower-counts"
               bind:checked="$disableFollowerCounts" on:change="onChange(event)">
        {"Hide follower counts (capped at 10)"}
      </label>
      <label class="setting-group">
        <input type="checkbox" id="choice-disable-reblog-counts"
               bind:checked="$disableReblogCounts" on:change="onChange(event)">
        {"Hide boost counts"}
      </label>
      <label class="setting-group">
        <input type="checkbox" id="choice-disable-fav-counts"
               bind:checked="$disableFavCounts" on:change="onChange(event)">
        {"Hide favorite and reaction counts"}
      </label>

      <h3>{"Immediacy"}</h3>

        <label class="setting-group">
          <input type="checkbox" id="choice-disable-unread-notification-counts"
                 bind:checked="$disableNotificationBadge" on:change="onChange(event)">
          {"Hide unread notifications count (i.e. the red dot)"}
        </label>
        <label class="setting-group">
          <input type="checkbox" id="choice-disable-notification-sound"
                 bind:checked="$disableNotificationSound" on:change="onChange(event)">
          {"Disable notification sounds"}
        </label>
        <label class="setting-group">
          <input type="checkbox" id="choice-disable-follow-request-count"
                 bind:checked="$disableFollowRequestCount" on:change="onChange(event)">
          {"Hide follow request count"}
        </label>
        <label class="setting-group">
          <input type="checkbox" id="choice-disable-relative-timestamps"
                 bind:checked="$disableRelativeTimestamps" on:change="onChange(event)">
          {"Show absolute timestamps (e.g. \"March 3rd\") instead of relative timestamps (e.g. \"5 minutes ago\")"}
        </label>

      <p>
        {"You can filter or disable notifications in the"}
        <a rel="prefetch" href="{singleInstance ? '/settings/account' : `/settings/instances${$currentInstance ? '/' + $currentInstance : ''}`}">{singleInstance ? "account settings" : "instance settings"}</a>.
        {[]}
      </p>
      <p>
        {@html "These settings are partly based on guidelines from the <a rel=\"noopener\" target=\"_blank\" href=\"https://humanetech.com\">Center for Humane Technology</a>."}
      </p>
  </form>

  {#if $isUserLoggedIn }
    <h2>{themeTitle}</h2>
    <ThemeSettings instanceName={$currentInstance} />
  {/if}
</SettingsLayout>
<UISettingsStyles />
<script>
  import SettingsLayout from '../../_components/settings/SettingsLayout.html'
  import ThemeSettings from '../../_components/settings/instance/ThemeSettings.html'
  import { store } from '../../_store/store.js'
  import Tooltip from '../../_components/Tooltip.html'
  import UISettingsStyles from '../../_components/settings/UISettingsStyles.html'
  import { formatIntl } from '../../_utils/formatIntl.js'

  export default {
    oncreate () {
      this.flushChangesToCheckAll()
    },
    components: {
      SettingsLayout,
      ThemeSettings,
      Tooltip,
      UISettingsStyles
    },
    methods: {

      flushChangesToCheckAll () {
        const {
          disableFollowerCounts,
          disableReblogCounts,
          disableFavCounts,
          disableNotificationBadge,
          disableNotificationSound,
          disableRelativeTimestamps,
          disableFollowRequestCount
        } = this.store.get()
        document.querySelector('#choice-check-all').checked = disableFollowerCounts &&
          disableReblogCounts &&
          disableFavCounts &&
          disableNotificationBadge &&
          disableNotificationSound &&
          disableRelativeTimestamps &&
          disableFollowRequestCount
      },
      onCheckAllChange (e) {
        const { checked } = e.target
        this.store.set({
          disableFollowerCounts: checked,
          disableReblogCounts: checked,
          disableFavCounts: checked,
          disableNotificationBadge: checked,
          disableNotificationSound: checked,
          disableRelativeTimestamps: checked,
          disableFollowRequestCount: checked
        })
        this.store.save()
      },
      onChange (event) {
        this.flushChangesToCheckAll()
        // these two are mutually exclusive
        const { markMediaAsSensitive, neverMarkMediaAsSensitive } = this.store.get()
        if (markMediaAsSensitive && neverMarkMediaAsSensitive) {
          if (event.target.id === 'choice-mark-media-sensitive') {
            this.store.set({ neverMarkMediaAsSensitive: false })
          } else {
            this.store.set({ markMediaAsSensitive: false })
          }
        }
        this.store.save()
      }
    },
    store: () => store,
    computed: {
      themeTitle: ({ $loggedInInstancesInOrder, $currentInstance }) => (
        $loggedInInstancesInOrder.length > 1
          ? formatIntl(["Theme for ",["instance"]], { instance: $currentInstance })
          : "Theme"
      )
    },
    data: () => ({
      singleInstance: process.env.SINGLE_INSTANCE
    })
  }
</script>
